/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Prop } from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {UgcItemInterface} from '@/store/modules/ugc-item/types';
import FormTranslation from '@/mixins/FormTranslation';
import FlexiColourStrip from '@/components/FlexiColourStrip/index.vue';
import {mixins} from 'vue-class-component';

const namespaceSettings: string = 'settingsModule';

/**
 * Revision details component.
 *
 * Component that provides a uniform loading component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-revision-details',
    components: {
        'c-flexi-colour-strip': FlexiColourStrip,
    },
})
export default class RevisionDetails extends mixins(FormTranslation) {
    @Prop(Object) public item!: UgcItemInterface;
    @Prop(String) public notes!: string;
    @Prop(String) public revisionId!: string;
    @Getter('hasMedia', {namespace: namespaceSettings}) public hasMedia!: (name: string) => boolean;

    /**
     * Revision UUID (mini) getter.
     *
     * @returns {string}
     */
    get revisionUuidMini(): string {
        if (!this.revisionId || 8 > this.revisionId.length) {
            return '';
        }

        return this.revisionId.substr(0, 8);
    }
}
